import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from '../../../common/components/runtime-context';
import RecentPostsItem from '../recent-posts-item';
import styles from './recent-posts-list-item.scss';
import { getIsViewsCountEnabled } from '../../../app/selectors/app-settings-selectors';
import withAuth from '../../../app/hoc/with-auth';
import withDeviceType from '../../../app/hoc/with-device-type';

export class RecentPostsListItem extends Component {
  render() {
    const { post, isPostNumbersEnabled, handleLikeClick, forPublicUser } = this.props;

    const componentProps = {
      post,
      handleLikeClick,
      forPublicUser,
      ...this.props,
      isPostNumbersEnabled,
    };

    return (
      <article className={styles.container} data-hook="recent-post-list-item">
        <RecentPostsItem {...componentProps} />
      </article>
    );
  }
}

RecentPostsListItem.propTypes = {
  post: PropTypes.object.isRequired,
  handleLikeClick: PropTypes.func.isRequired,
  isPostNumbersEnabled: PropTypes.bool,
  forPublicUser: PropTypes.func.isRequired,
  withCover: PropTypes.bool.isRequired,
  isViewsCountEnabled: PropTypes.bool.isRequired,
};

RecentPostsListItem.defaultProps = {
  titleFontClassName: 'forum-post-title-font',
  titleFontColorClassName: 'forum-post-title-color',
};

const mapRuntimeToProps = (state, ownProps, actions, host) => ({
  isViewsCountEnabled: getIsViewsCountEnabled(state, host.style),
});

// prettier-ignore
export default flowRight(
  withAuth,
  withDeviceType,
  connect(mapRuntimeToProps),
)(RecentPostsListItem);
